import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b681f8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Monitoring" }
const _hoisted_2 = { class: "Monitoring__content" }
const _hoisted_3 = { class: "content__stats" }
const _hoisted_4 = { class: "Monitoring__filters" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_7 = { class: "content__map bg-white rounded p-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold uppercase" }, "Карта", -1))
const _hoisted_9 = { class: "mt-4 rounded border border-gray-200 py-3 px-4 flex items-center justify-between" }
const _hoisted_10 = { class: "grid grid-cols-3 items-center gap-5" }
const _hoisted_11 = { class: "mt-4 rounded border border-gray-200 py-3 px-4" }
const _hoisted_12 = { class: "map__sectors" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center justify-center select-none"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка списка секторов...", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, " При получении списка секторов произошла ошибка ", -1))
const _hoisted_16 = {
  key: 2,
  class: "text-sm text-gray-400"
}
const _hoisted_17 = { class: "sectors__list" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Сектор", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_monitoring_stats = _resolveComponent("monitoring-stats")!
  const _component_new_map = _resolveComponent("new-map")!
  const _component_type_switcher = _resolveComponent("type-switcher")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Мониторинг" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_new_input, {
            type: "date",
            placeholder: "Дата (с)",
            value: _ctx.filters.createdAtFrom,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.createdAtFrom) = $event)),
            onChange: _ctx.loadData
          }, null, 8, ["value", "onChange"]),
          _createVNode(_component_new_input, {
            type: "date",
            placeholder: "Дата (по)",
            value: _ctx.filters.createdAtTo,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.createdAtTo) = $event)),
            onChange: _ctx.loadData
          }, null, 8, ["value", "onChange"]),
          _createVNode(_component_new_button, {
            disabled: 
                            _ctx.deliveries_state.is_loading ||
                            _ctx.takes_state.is_loading ||
                            _ctx.couriers_state.is_loading
                        ,
            class: "NewButton--reset",
            onClick: _ctx.resetData
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_new_button, {
            disabled: 
                            _ctx.deliveries_state.is_loading ||
                            _ctx.takes_state.is_loading ||
                            _ctx.couriers_state.is_loading
                        ,
            class: "NewButton--search",
            onClick: _ctx.loadData
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _createVNode(_component_monitoring_stats, {
          title: "Доставки",
          img: "/monitoring/delivery.png",
          statistics: _ctx.deliveries_state.stats,
          loading: _ctx.deliveries_state.is_loading,
          failed: _ctx.deliveries_state.is_failed,
          "error-text": "При получении статистики доставок произошла ошибка",
          "empty-text": "Список статистики доставок пуст",
          "is-delivery": "",
          onReload: _ctx.loadDeliveries
        }, null, 8, ["statistics", "loading", "failed", "onReload"]),
        _createVNode(_component_monitoring_stats, {
          title: "Заборы",
          img: "/monitoring/takes.png",
          statistics: _ctx.takes_state.stats,
          loading: _ctx.takes_state.is_loading,
          failed: _ctx.takes_state.is_failed,
          "error-text": "При получении статистики заборов произошла ошибка",
          "empty-text": "Список статистики заборов пуст",
          onReload: _ctx.loadTakes
        }, null, 8, ["statistics", "loading", "failed", "onReload"]),
        _createVNode(_component_monitoring_stats, {
          title: "Курьеры (Забор/доставка)",
          img: "/monitoring/couriers.png",
          "statistics-couriers": _ctx.couriers_state.stats,
          loading: _ctx.couriers_state.is_loading,
          failed: _ctx.couriers_state.is_failed,
          "error-text": "При получении статистики курьеров произошла ошибка",
          "empty-text": "Список статистики курьеров пуст",
          "is-couriers": "",
          onReload: _ctx.loadCouriers
        }, null, 8, ["statistics-couriers", "loading", "failed", "onReload"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_new_map, {
          class: "monitoring__map mt-4",
          id: "monitoring-map",
          controls: ['zoomControl'],
          onMapReady: _ctx.onMapReady
        }, null, 8, ["onMapReady"]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_type_switcher, {
            value: _ctx.state.map_orders_types,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.map_orders_types) = $event)),
            disabled: _ctx.isMapOrdersTypesDisabled,
            options: _ctx.MAP_ORDERS_TYPES,
            onChange: _ctx.rerenderMapData
          }, null, 8, ["value", "disabled", "options", "onChange"]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_new_checkbox, {
              value: 
                                _ctx.delivery_completed_orders_state.is_showed ||
                                _ctx.takes_completed_orders_state.is_showed
                            ,
              disabled: _ctx.isMapOrdersTypesDisabled,
              class: "checkbox--green",
              label: "Завершено",
              onChange: _ctx.onCompletedTypeChange
            }, null, 8, ["value", "disabled", "onChange"]),
            _createVNode(_component_new_checkbox, {
              value: 
                                _ctx.delivery_remained_orders_state.is_showed ||
                                _ctx.takes_remained_orders_state.is_showed
                            ,
              disabled: _ctx.isMapOrdersTypesDisabled,
              class: "checkbox--yellow",
              label: "Остаток",
              onChange: _ctx.onRemainedTypeChange
            }, null, 8, ["value", "disabled", "onChange"]),
            _createVNode(_component_new_checkbox, {
              value: 
                                _ctx.delivery_cancelled_orders_state.is_showed ||
                                _ctx.takes_cancelled_orders_state.is_showed
                            ,
              disabled: _ctx.isMapOrdersTypesDisabled,
              class: "checkbox--red",
              label: "Отменено",
              onChange: _ctx.onCancelledTypeChange
            }, null, 8, ["value", "disabled", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (
                                _ctx.sectors_list_state.is_loading ||
                                _ctx.sectors_list_state.is_failed ||
                                _ctx.sectors_list_state.options.length === 0
                            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.sectors_list_state.is_loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_loader, { class: "primary" }),
                        _hoisted_14
                      ], 64))
                    : (_ctx.sectors_list_state.is_failed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_15,
                          _createVNode(_component_new_button, {
                            class: "NewButton--outline mt-1",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadDeliverySectors(_ctx.filters.dispatcherSectorId)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Обновить ")
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_ctx.sectors_list_state.options.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Список секторов пуст"))
                        : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectors_list_state.options, (sector) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: sector.id,
                  class: "list__item flex items-center cursor-pointer",
                  onClick: ($event: any) => (_ctx.setMapCenterOnSector(sector))
                }, [
                  _hoisted_19,
                  _createElementVNode("span", {
                    class: "text-sm font-bold ml-2",
                    style: _normalizeStyle({ color: sector.color })
                  }, _toDisplayString(sector.name), 5)
                ], 8, _hoisted_18))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}